export const baseURL =
  process.env.REACT_APP_API_BASE_URL ||
  "https://61ys938h60.execute-api.eu-central-1.amazonaws.com";
